<template>
  <mw-dialog ref="dialog" size="form" :appendToBody="false" :title="title" :footerButton="footerButton"  customClass="mw-flow-complete"  :beforeClose="beforeClose">
    <div class="__form_content">
      <template v-if="false">
        <div class="__sel"> <span class="__btn">{{$lang("未获取到符合条件的流向信息")}}</span></div>
      </template>
      <template v-for="flow in workFlows">
        <mw-wt-li :ref="'wtli'+flow.id" :rowStyle="rowStyle" :flowId="flow.id" :flowName="flow.name"
                    :flowType="flow.type" :params="params" :activityId="flow.activityId"
                    :candidates="candidates[flow.id]" :planneds="planneds[flow.id]"
                    :doings="doings[flow.id]" :finisheds="flow.finisheds" :options="flow.options">
        </mw-wt-li>
      </template>
    </div>
  </mw-dialog>
</template>
<script>
import MwWtLi from "./worktrack/liwt.vue";

export default {
  components: {
    MwWtLi
  },
  props: {
    params: {
      type: Object
    }
  },
  data() {
    let me=this;
    return {
      title:$lang('运转跟踪'),
      fCount:0,
      workFlows:[],
      candidates:{},
      planneds:{},
      doings:{},
      rowStyle:'height:225px; padding-top:5px;',

      footerButton: [
        {
          label: $lang("关闭"),
          type: "default",
          func:me.close
        },
        {
          label: $lang("确定"),
          func:me.submit
        }
      ]
    }
  },
  mounted() {
    setTimeout(()=>{
      this.show();
    },200)
    this.init();
  },
  watch: {
    params(){
      this.init();
    }
  },
  methods: {
    setBtnLoading(loading,idx){
       this.footerButton[idx].loading=loading;
    },
  btnDebounce:_.debounce(function(callback){
    let me=this;
    if(callback){
    callback();
    }
    }, 1000, {
    'leading': true,
    'trailing': false
   }),
    init(){
      var me = this;
      me.mwApi.process.getWorkFlowLists({taskId:me.params.taskId}).then((data)=>{
         let res=data.result;
         if(typeof res.success !='undefined' && !res.success){
            me.fCount = 0;
            return;
         }
         me.workFlows = res;
         me.fCount = res.length;
         me.rowStyle='height:'+Math.floor(100/me.fCount)+'%; padding-top:5px;';
         res.map((wf)=>{
           var fcandidates=[];
           var fplanneds=[];
           var fdoings=[];
           let cidx=0;
           if(wf.candidates){ //可选
             var cIds=[];
             wf.candidates.map((v)=>{
                if(!v.hidden){
                   if(cIds.indexOf(v.id)==-1){
                      var node = Object.assign({},v);
                      node.text = v.name;
                      node.flowId = wf.id;
                      node.idx = cidx++;
                      fcandidates.push(node);
                      cIds.push(v.id);
                   }
                }
             });
           }
           if(wf.planneds){ //已选
             wf.planneds.map((v)=>{
               var node = me._subPlannedAsNode(v);
               node.flowId = wf.id;
               fplanneds.push(node);
             });
           }
           if(wf.doings){ //在办
             wf.doings.map((v)=>{
               var node = me._subPlannedAsNode(v);
               node.flowId = wf.id;
               fdoings.push(node);
             });
           }
           me.candidates[wf.id]=fcandidates;
           me.planneds[wf.id]=fplanneds;
           me.doings[wf.id]=fdoings;
         });
      });
    },
   submit(){ //保存已选
      var me = this;
      me.btnDebounce(function(){
          me.setBtnLoading(true,1);
          let activities=[];
          me.workFlows.map((v)=>{
          var activity={};
          activity.flowId=v.id;
          activity.activityId=v.activityId;
          activity.type = v.type;
          activity.options=v.options;
          activity.items = me.mwRef("wtli"+v.id)[0].getPlannedsData();
          activities.push(activity);
          });
          var params={};
          params.taskId = me.params.taskId;
          params.appId = me.params.appId;
          params.formId = me.params.formId;
          params.activities=activities;
          me.mwApi.process.planned(params).then((res)=>{
          me.close();
          me.formActionComplete();
          me.setBtnLoading(false,1);
          }).catch(()=>{
          me.setBtnLoading(false,1);
          });
      });
   },
    beforeClose(done){
      var me = this;
      me.mwConfirm($lang('确定退出运转跟踪窗口？')).then(_=>{
        if(me.params.secondfunc){
          me.params.secondfunc();
        }
        me.resetForm();
        done();
      }).catch(_=>{});
    },
    formActionComplete(){
      var me = this;
      if(me.params.func){
        me.params.func();
      }
      this.resetForm();
    },
    close(){
      this.resetForm();
      this.mwRef('dialog').hide();
    },
    show(){
      this.mwRef('dialog').show();
    },
    resetForm(){
      var me = this;
      me.workFlows = [];
      me.candidates = {};
      me.planneds = {};
      me.doings = {};
      me.fCount=0;
      me.rowStyle='height:225px; padding-top:5px;';
    },
     _subPlannedAsNode(v){
       var node = {};
       node.id=v.masterObjectId;
       node.name=v.masterObjectName;
       if(v.masterObjectType=='USER'){
         node.type = 'U';
         node.departmentId = v.masterObjectDeptId;
       }else{
         node.type='D';
       }
       if(v.identities){
         node.identities = v.identities;
       }
       node.text = v.masterObjectName;
       return node;
     }
  }
}
</script>





// WEBPACK FOOTER //
// src/common/components/public-dialog/worktrackLi.vue